import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function HeroSection() {
  return <section id="hero" className="relative min-h-screen flex items-center justify-center bg-[url('https://cdn.magicpatterns.com/uploads/wGDYsXSD9FnXCsTY7v8yqU/star-h2yxLJJTPvw-unsplash.jpg')] bg-scroll md:bg-fixed bg-cover bg-center pt-20" data-id="element-132">
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/[0.55]" data-id="element-133" />

      {/* Localized radial gradient — darker center for text, lighter edges to show landscape */}
      <div className="absolute inset-0" style={{
      background: 'radial-gradient(ellipse 70% 60% at 50% 50%, rgba(0,0,0,0.35) 0%, rgba(0,0,0,0) 100%)'
    }} data-id="element-134" />

      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto flex flex-col items-center" data-id="element-135">
        <img src="https://cdn.magicpatterns.com/uploads/gprocNPki3pb3xLHuGwAyG/first-responder-owned-and-operated-company.jpg" alt="First Responder Owned and Operated" className="w-24 h-24 md:w-32 md:h-32 mb-8 bg-white rounded-full p-2 shadow-2xl object-cover" data-id="element-136" />

        <h1 className="text-[#FFFFFF] font-extrabold uppercase tracking-wider text-3xl md:text-5xl lg:text-6xl mb-6 leading-tight" style={{
        textShadow: '0 2px 8px rgba(0,0,0,0.7)'
      }} data-id="element-137">
          Restore Your Pool's Sparkle Today
        </h1>

        <p className="text-[#F0F0F0] text-lg md:text-xl mb-10 max-w-3xl leading-relaxed" style={{
        textShadow: '0 1px 6px rgba(0,0,0,0.6)'
      }} data-id="element-138">
          Expert Pool Tile Cleaning, Acid Washes & Chlorine Washes — First
          Responder Owned & Operated in Arizona
        </p>

        <a href="#contact" className="bg-brand-red hover:bg-brand-red-dark text-white rounded-lg px-8 py-4 text-lg md:text-xl font-bold transition-all duration-300 w-full sm:w-auto text-center shadow-lg hover:shadow-brand-red/50 hover:-translate-y-1" data-id="element-139">
          Get a Free Quote
        </a>

        <div className="mt-10 md:mt-16 flex flex-wrap justify-center items-center gap-2 md:gap-6 text-[#F0F0F0] text-xs md:text-base font-medium bg-black/30 px-4 md:px-6 py-3 rounded-2xl md:rounded-full backdrop-blur-sm" data-id="element-140">
          <span className="flex items-center gap-2" data-id="element-141">
            <ShieldCheckIcon className="w-5 h-5 text-brand-red" data-id="element-142" /> Licensed
          </span>
          <span className="hidden md:inline text-gray-400" data-id="element-143">•</span>
          <span className="flex items-center gap-2" data-id="element-144">
            <ShieldCheckIcon className="w-5 h-5 text-brand-red" data-id="element-145" /> Bonded
          </span>
          <span className="hidden md:inline text-gray-400" data-id="element-146">•</span>
          <span className="flex items-center gap-2" data-id="element-147">
            <ShieldCheckIcon className="w-5 h-5 text-brand-red" data-id="element-148" /> Insured
          </span>
          <span className="hidden lg:inline text-gray-400" data-id="element-149">•</span>
          <span className="flex items-center gap-2 w-full justify-center lg:w-auto mt-2 lg:mt-0" data-id="element-150">
            <ShieldCheckIcon className="w-5 h-5 text-brand-red" data-id="element-151" /> First
            Responder Owned
          </span>
        </div>
      </div>
    </section>;
}